import React, { useEffect } from 'react'
import Header from '../components/Header/Header'
import NavBar from '../components/NavBar/NavBar'
import Projects from '../components/Projects/Projects'
import Skills from '../components/Skills/Skills'
import ContactForm from '../components/ContactForm/ContactForm'
import Aos from 'aos'
import 'aos/dist/aos.css'

const HomeScreen = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 })
  }, [])

  return (
    <>
      <NavBar className="md sm lg xl 2xl" />
      <div className="container">
        <Header className="md sm lg xl 2xl" />
        <Skills className="md sm lg xl 2xl" />
        <Projects className="md sm lg xl 2xl" />
      </div>
      <ContactForm className="md sm lg xl 2xl" />
    </>
  )
}

export default HomeScreen
